import React from 'react'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { MinusIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS } from '../../../../constants/colors'

export interface CallHeaderProps {
  teamName: string
  connectionState: string
  connectionLabel: string
  onMinimize?: () => void
  minimizeTooltip: string
}

export const CallHeader: React.FC<CallHeaderProps> = ({
  teamName,
  connectionState,
  connectionLabel,
  onMinimize,
  minimizeTooltip
}) => {
  const isConnected = connectionState === 'connected'

  return (
    <Box
      className={onMinimize ? 'whereby-drag-handle' : undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        cursor: onMinimize ? 'grab' : 'default',
        userSelect: 'none',
        '&:active': onMinimize ? { cursor: 'grabbing' } : {}
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Typography sx={{ fontSize: '18px', lineHeight: '24px', fontWeight: 600, color: INTERAX_COLORS.white }}>
          {teamName}
        </Typography>

        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            padding: '6px 12px',
            borderRadius: '999px',
            backgroundColor: isConnected ? `${INTERAX_COLORS.green}33` : `${INTERAX_COLORS.sun}33`
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '999px',
              backgroundColor: isConnected ? INTERAX_COLORS.green : INTERAX_COLORS.sun
            }}
          />
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: INTERAX_COLORS.white,
              textTransform: 'uppercase',
              letterSpacing: '0.08em'
            }}
          >
            {connectionLabel}
          </Typography>
        </Box>
      </Box>

      {onMinimize !== undefined ? (
        <Tooltip title={minimizeTooltip}>
          <IconButton
            onClick={onMinimize}
            size="small"
            sx={{
              width: 32,
              height: 32,
              backgroundColor: INTERAX_COLORS.sun,
              color: INTERAX_COLORS.offBlack,
              borderRadius: '999px',
              '&:hover': { backgroundColor: INTERAX_COLORS.sun40 }
            }}
          >
            <MinusIcon style={{ width: 16, height: 16 }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
  )
}
